import { IComponentOptions, IIntervalService, IPromise } from 'angular';
import * as template from './carousel.html';

const FIRST_SLIDE_INDEX = 0;
const INTERVAL_TIME = 3000;

interface ICarouselItemImage {
  name: string;
  fileType: string;
  fileSource: string;
}

interface ICarouselItem {
  id: string;
  url: string;
  isNew: boolean;
  active: boolean;
  image: ICarouselItemImage;
}

interface ICarouselComponentBindings {
  items: ICarouselItem[];
  intervalTime: number;
}

interface ICarouselComponentController extends ICarouselComponentBindings {
  startInterval(): void;
  stopInterval(): void;
  nextSlide(): void;
  previousSlide(): void;
  goToSlide(slideNo: number): void;
}

class CarouselController implements ICarouselComponentController {
  static $inject = ['$interval'];

  public items: any[];
  public pause = false;
  public intervalTime: number;

  private slideNo: number;
  private stop: IPromise<any>;

  constructor(protected $interval: IIntervalService) {}

  $onInit() {
    this.slideNo = FIRST_SLIDE_INDEX;
    this.intervalTime = this.intervalTime || INTERVAL_TIME;
    this.startInterval();
  }

  $onDestroy() {
    this.stopInterval();
  }

  startInterval() {
    this.stop = this.$interval(() => {
      this.nextSlide();
    }, this.intervalTime);
  }

  stopInterval() {
    this.$interval.cancel(this.stop);
  }

  pauseInterval() {
    this.pause = true;
  }

  resumeInterval() {
    this.pause = false;
  }

  nextSlide() {
    if (!this.pause) {
      this.goToSlide(this.slideNo + 1);
    }
  }

  previousSlide() {
    this.goToSlide(this.slideNo - 1);
  }

  goToSlide(slideNo) {
    const { length } = this.items;
    if (length) {
      let newSlideNo = slideNo;

      if (newSlideNo >= length) {
        newSlideNo = 0;
      }

      if (newSlideNo < 0) {
        newSlideNo = length - 1;
      }

      this.items.forEach((item) => {
        item.active = false;
      });
      this.slideNo = newSlideNo;
      this.items[newSlideNo].active = true;
    }
  }
}

export default class CarouselComponent implements IComponentOptions {
  public bindings: any;
  public template: any;
  public controller: any;

  constructor() {
    this.bindings = {
      items: '<',
      intervalTime: '<',
    };
    this.template = template;
    this.controller = CarouselController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/carousel/carousel-component.ts